import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  MenuItem,
  Modal,
  Select,
  Button,
  FormControl,
  InputLabel,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { isValidInput } from "../utils/validations";

interface RejectedReasonDetailModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedReasonType: string;
  setSelectedReasonType: Dispatch<SetStateAction<string>>;
  setRejectionRsn: any;
  rejectionRsn: string | undefined;
  handleSubmit: () => void;
}

export default function RejectedReasonDetailModal({
  open,
  onClose,
  setOpen,
  selectedReasonType,
  setSelectedReasonType,
  setRejectionRsn,
  rejectionRsn,
  handleSubmit,
}: RejectedReasonDetailModalProps) {
  const handleChange = (event: SelectChangeEvent) => {
    setSelectedReasonType(event.target.value);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      className="modal rejectedReasonDetail_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Rejected Reason Detail</h2>
            <div className="btn-close" onClick={handleCancel}>
              <CloseIcon />
            </div>
          </div>
          <div className="control_group w_50">
            {/* <FormControl fullWidth>
              <InputLabel id="reason_to">Reason</InputLabel>
              <Select
                labelId="reason_to"
                id="reason_to"
                // value={selectedReasonType}
                onChange={handleChange}
              >
                {" "}
                <MenuItem disabled value="Select Profession" />
                <MenuItem value={1}>Profile</MenuItem>
                <MenuItem value={2}>document</MenuItem>
              </Select>
            </FormControl> */}

            <Select
              fullWidth
              labelId="country_to"
              id="country_to"
              displayEmpty
              value={selectedReasonType}
              onChange={handleChange}
            >
              <MenuItem disabled value="">
                Select Reason
              </MenuItem>
              <MenuItem value={1}>Profile</MenuItem>
              <MenuItem value={2}>document</MenuItem>
            </Select>
          </div>
          <div className="control_group">
            <label>Add Reason</label>
            <TextField
              placeholder="Enter Reason"
              fullWidth
              hiddenLabel
              multiline
              maxRows={5}
              minRows={5}
              value={rejectionRsn}
              onChange={(val) => {
                if (isValidInput(val.target.value)) {
                  setRejectionRsn(val.target.value);
                }
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "30px",
              justifyContent: "center",
              paddingTop: "20px",
            }}
          >
            <Button
              className="btn btn_primary"
              sx={{ minWidth: "100px" }}
              // sx={{ color: "#252525", border: "1px solid #252525" }}
              onClick={() => {
                setOpen(false);
                handleSubmit();
                setRejectionRsn("");
                setSelectedReasonType("");
              }}
            >
              Reject
            </Button>

            <Button
              className="btn btn_primary"
              sx={{ minWidth: "100px" }}
              // sx={{ color: "#252525", border: "1px solid #252525" }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
